<template>
  <div class="searchPage">
<!--    <div>-->
<!--      <otherNav></otherNav>-->
<!--    </div>-->
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-sm-12">
        <div v-if="searchList.length > 0">
        <div style="text-align: left" v-for="item in this.searchList" :key="item.id">
<!--          {{item.type, item.url,item.title}}-->
          <router-link class="resourceTitle" v-if="item.type==='seeds'" :to="item.url" >{{item}}--{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-if="item.type==='seedNew'" :to="item.url" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='dna'" :to="item.url" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='dryBlade'" :to="item.url" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='animalGermplasmNew'" :to="item.url" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='dnaBarPlant'" :to="item.url" >{{ item.title }}</router-link>
<!--          <router-link class="resourceTitle" v-else-if="item.type==='spineAnimal'" :to="item.url" >{{ item.title }}</router-link>-->
          <router-link class="resourceTitle" v-else-if="item.type==='dnaBarZoo'" :to="item.url" >{{ item.growLatin }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='riskPlantDirectory'" :to="item.url" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='specificPlantDirectory'" :to="item.url" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='bershuraMountains'" to="/resourceBase/list/protectedWildPlants" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='nujiangPrefectureWildPlants'" to="/resourceBase/list/wildPlants" >{{ item.title }}</router-link>
          <router-link class="resourceTitle" v-else-if="item.type==='terrestrialWildlife'" to="/resourceBase/list/terrestrialWildlife" >{{ item.title }}</router-link>

          <div class="title" v-else @click="toDetail(item)">{{ item.title }}</div>
          <div class="type" v-if="item.type=='information'">类型： 动态资讯</div>
          <div class="type" v-else-if="item.type=='progressWork'">类型： 工作进展</div>
          <div class="type" v-else-if="item.type=='problem'">类型： 常见问题</div>
          <div class="type" v-else-if="item.type=='relationWe'">类型： 联系我们</div>
          <div class="type" v-else-if="item.type=='picture'">类型： 图片</div>
          <div class="type" v-else-if="item.type=='video'">类型： 视频</div>
          <div class="type" v-else-if="item.type=='fieldData'">类型： 野外数据填写规范（植物）</div>
          <div class="type" v-else-if="item.type=='collectManagement'">类型： 种质资源采集和管理规范</div>
          <div class="type" v-else-if="item.type=='bershuraMountains'">类型： 高黎贡山-伯舒拉岭重点保护野生植物名录
            <span class="type-name">种中文名: {{item.growChinese}} &nbsp;</span>
            <span class="type-name">种拉丁名: {{item.growLatin}} &nbsp;</span>
          </div>
<!--          植物种质旧版-->
          <div class="type" v-else-if="item.type=='seeds'"><span class="type-title">类型： 种子</span>
          <span class="type-name">种中文名: {{item.growChinese}} &nbsp;</span>
          <span class="type-name">种拉丁名: {{item.growLatin}} &nbsp;</span>
          <span class="type-name">科中文名: {{item.sectionChinese}}  &nbsp;</span>
          <span class="type-name">科拉丁名: {{item.sectionLatin}}  &nbsp;</span>
          </div>
<!--          植物种质种子-->
          <div class="type" v-else-if="item.type=='seedNew'"><span class="type-title">类型： 种子</span>
            <span class="type-name">种中文名: {{item.growChinese}} &nbsp;</span>
            <span class="type-name">种拉丁名: {{item.growLatin}} &nbsp;</span>
            <span class="type-name">科中文名: {{item.sectionChinese}}  &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.sectionLatin}}  &nbsp;</span>
          </div>
<!--          DNA-->
          <div class="type" v-else-if="item.type=='dna'"><span class="type-title">类型： DNA</span>
            <span class="type-name">种中文名: {{item.growChinese}} &nbsp;</span>
            <span class="type-name">种拉丁名: {{item.growLatin}} &nbsp;</span>
            <span class="type-name">科中文名: {{item.sectionChinese}}  &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.sectionLatin}}  &nbsp;</span>
          </div>
<!--          干燥叶片-->
          <div class="type" v-else-if="item.type=='dryBlade'"><span class="type-title">类型： 干燥叶片</span>
            <span class="type-name">种中文名: {{item.growChinese}} &nbsp;</span>
            <span class="type-name">种拉丁名: {{item.growLatin}} &nbsp;</span>
            <span class="type-name">科中文名: {{item.sectionChinese}}  &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.sectionLatin}}  &nbsp;</span>
          </div>
<!--          动物种质-->
          <div class="type" v-else-if="item.type=='animalGermplasmNew'"><span class="type-title">类型： 动物种质</span>
            <span class="type-name">种中文名: {{item.growChinese}} &nbsp;</span>
            <span class="type-name">种拉丁名: {{item.growLatin}} &nbsp;</span>
            <span class="type-name">属拉丁名: {{item.belongLatin}}  &nbsp;</span>
            <span class="type-name">属中文名: {{item.belongChinese}}  &nbsp;</span>
            <span class="type-name">科中文名: {{item.sectionChinese}}  &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.sectionLatin}}  &nbsp;</span>
          </div>
<!--          脊椎动物-->
          <div class="type" v-else-if="item.type=='dnaBarZoo'"><span class="type-title">类型： 脊椎动物</span>
<!--            <span class="type-name" v-if="item.growChinese !==''">种中文名: {{item.growChinese}} &nbsp;</span>-->
<!--            <span class="type-name" v-if="item.growLatin !==''">种拉丁名: {{item.growLatin}} &nbsp;</span>-->
<!--            <span class="type-name">属拉丁名: {{item.belongLatin}}  &nbsp;</span>-->
<!--            <span class="type-name" v-if="item.belongChinese !==''">属中文名: {{item.belongChinese}}  &nbsp;</span>-->
            <span class="type-name" v-if="item.sectionChinese !==''">科中文名: {{item.sectionChinese}}  &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.sectionLatin}}  &nbsp;</span>
          </div>
<!--          维管植物-->
          <div class="type" v-else-if="item.type=='dnaBarPlant'"><span class="type-title">类型： 维管植物</span>
<!--            <span class="type-name">中文名: {{item.chineseName}} &nbsp;</span>-->
<!--            <span class="type-name">学名: {{item.scientificName}} &nbsp;</span>-->
            <span class="type-name">科中文名: {{item.sectionChinese}}  &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.sectionLatin}}  &nbsp;</span>
          </div>
<!--          受威胁-->
          <div class="type" v-else-if="item.type=='riskPlantDirectory'"><span class="type-title">类型： 高黎贡山-伯舒拉岭受威胁植物名录</span>
            <span class="type-name">科中文名: {{item.sectionChinese}} &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.sectionLatin}} &nbsp;</span>
          </div>
<!--          特有植物-->
          <div class="type" v-else-if="item.type=='specificPlantDirectory'"><span class="type-title">类型： 高黎贡山特有植物名录</span>
            <span class="type-name">科中文名: {{item.growChinese}} &nbsp;</span>
            <span class="type-name">科拉丁名: {{item.growLatin}} &nbsp;</span>
          </div>
          <el-divider></el-divider>
        </div>
        <div>
          <el-pagination class="pagin"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
        </div>
          <el-empty v-else description="没有找到数据" style="width: 20%;margin: 0 auto" ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'
import { getGlobalInfo } from '@/network/searchPage'
export default {
  name: "searchPage",
  components: {  otherNav },
  data() {
    return {
      searchForm: {
        title: '',
      },
      token: '',
      page: 1,
      pageSize: 10,
      total: 0,
      searchList: [],
      url: '',
    }
  },
  activated() {
    if(!this.$route.meta.isUseCache) {
      this.searchList = []
      this.$EventBus.$on('searchEvent', (val,total,page,pageSize, title) => {
        // console.log('searchEvent',val,total,page,pageSize)
        this.searchList = val
        this.total = total
        this.page = page
        this.pageSize = pageSize
        this.searchForm.title = title
      })
    }else {
      this.$route.meta.isUseCache = false
    }
  },
  mounted() {
    // console.log('5675',localStorage.getItem('access_token'))
    // if(localStorage.getItem('access_token')) {
    //   this.token = localStorage.getItem('access_token')
    // } else {
    //   this.token = ''
    // }
    this.searchForm.title = this.$route.query.title
    // console.log(this.title)
    this.onSubmit(this.title,this.page,this.pageSize)
    // console.log(this.$route.query.title)
    // this.page = parseInt(this.$route.query.page)
    // this.pageSize = parseInt(this.$route.query.pageSize)
    // this.total = parseInt(this.$route.query.total)
    // this.searchList = this.$route.query.searchList
    // console.log(this.searchForm.title,this.page,this.pageSize,this.total,this.searchList)
    // this.onSubmit(this.$route.query.title,this.$route.query.page,this.$route.query.pageSize)
    this.$EventBus.$on('searchEvent', (val,total,page,pageSize, title) => {
      // console.log(title)
      this.searchList = val
      this.total = total
      this.page = page
      this.pageSize = pageSize
      this.searchForm.title = title
    })


  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
    onSubmit(title,page,pageSize) {
      //全局搜索
      getGlobalInfo({title: this.searchForm.title,page: this.page,pageSize: this.pageSize}).then(res => {
        this.searchList = res.data.data.globalVoList
        this.total = res.data.data.total
      })
    },
    toDetail(detail) {
      // console.log(detail)
      // console.log(detail, this.token)
      // if(this.token === '') {
      //   this.$message.error('你还未登录！请先登录')
      //   this.$router.push('/login')
      // }else {
        this.$router.push({
          path: '/detail/'+ detail.id + '/' + detail.type,
        })
      // }

    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.onSubmit()

    },
    handleCurrentChange(val){
      this.page = val
      this.onSubmit()
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/searchPage";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>